import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, delay, throwError, from, switchMap, map, reduce } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';
import { UserRoleService } from 'src/app/core/services/role.service';
import { environment } from 'src/environments/environment';
import { MockDataService } from './mock-data.service';
import {
    Banner,
    News,
    NewsApiResponse,
    NewsCreateRequest,
    NewsUpdateRequest,
    MaterialType,
    MaterialTypeApiResponse,
    MaterialTypeCreateRequest,
    MaterialTypeUpdateRequest,
    SuggestionType,
    SuggestionTypeApiResponse,
    SuggestionTypeRequest,
    Documentation,
    CampaignEntry,
    WorkshopType,
    EmailConfiguration,
    EmailNotification,
    EmailNotificationRequest,
    NotificationType,
    SmtpConfig,
    SmtpCreateRequest,
    SmtpUpdateRequest,
    SmtpTestRequest,
    SmtpTestResponse,
    WhatsAppConfig,
    WhatsAppCreateRequest,
    WhatsAppUpdateRequest,
    WhatsAppTestResponse,
    LineConfig,
    LineCreateRequest,
    LineUpdateRequest,
    LineTestResponse,
    SmsConfig,
    SmsCreateRequest,
    SmsUpdateRequest,
    SmsTestResponse,
    IncentiveTravel,
    IncentiveTravelUpdateData,
    NewIncentiveTravelFile,
    IncentiveTravelRequirement,
    IncentiveTravelRequirementRequest,
    IncentiveTravelRequirementApiResponse,
    IncentiveTravelProgress,
    IncentiveTravelPoint,
    IncentiveTravelPointRequest,
    IncentiveTravelPointsResponse,
    IncentiveTravelPointApiResponse,
    RappelPlanType,
    Provider
} from '../models';

@Injectable({
    providedIn: 'root'
})
export class ContentManagementService {

    // Flag to enable/disable mock mode  
    private useMockData = false;

    // Mock data storage
    // private mockBanners: Banner[] = [
    //     {
    //         id: "1",
    //         title: 'Promoción Neumáticos de Invierno 2025',
    //         imageUrl: 'assets/images/banners/banner1.jpg',
    //         thumbnailUrl: 'assets/images/banners/banner1-thumb.png',
    //         displayOrder: 1,
    //         isPublished: true,
    //         createdAt: new Date('2025-01-15'),
    //         updatedAt: new Date('2025-01-20'),
    //         startDate: new Date('2025-01-20').toDateString(),
    //         expirationDate: new Date('2025-03-31').toDateString()
    //     },
    //     {
    //         id: "2",
    //         title: 'Nueva Gama de Aceites Premium',
    //         imageUrl: 'assets/images/banners/banner2.jpg',
    //         thumbnailUrl: 'assets/images/banners/banner2-thumb.png',
    //         displayOrder: 2,
    //         isPublished: true,
    //         createdAt: new Date('2025-01-10'),
    //         updatedAt: new Date('2025-01-18'),
    //         startDate: new Date('2025-02-01').toDateString(),
    //         expirationDate: new Date('2025-06-30').toDateString()
    //     },
    //     {
    //         id: "3",
    //         title: 'Campaña Primavera - Revisión Completa',
    //         imageUrl: 'assets/images/banners/banner3.jpg',
    //         thumbnailUrl: 'assets/images/banners/banner3-thumb.png',
    //         displayOrder: 3,
    //         isPublished: false,
    //         createdAt: new Date('2025-01-22'),
    //         updatedAt: new Date('2025-01-22'),
    //         startDate: new Date('2025-03-01').toDateString(),
    //         expirationDate: new Date('2025-05-15').toDateString()
    //     }
    // ];

    private mockNews: News[] = [
        {
            id: '1',
            centerGroupId: 0,
            title: 'Nuevas regulaciones para neumáticos en 2025',
            description: 'La Unión Europea ha implementado nuevas regulaciones sobre el etiquetado de neumáticos que entrarán en vigor este año. Estas medidas buscan mejorar la seguridad vial y reducir el impacto ambiental.',
            creationDate: new Date('2025-01-20'),
            previewFileUri: 'https://www.point-s-group.com/wp-content/themes/points/images/logo.png',
            viewFileUri: 'https://www.cte.iup.edu/cte/Resources/PDF_TestPage.pdf',
            viewFileType: 0,
            isPublished: true,
            // Campos de retrocompatibilidad
            publicationDate: new Date('2025-01-20'),
            thumbnailUrl: 'https://www.point-s-group.com/wp-content/themes/points/images/logo.png',
            attachmentUrl: 'https://www.cte.iup.edu/cte/Resources/PDF_TestPage.pdf',
            createdAt: new Date('2025-01-18'),
            updatedAt: new Date('2025-01-20')
        },
        {
            id: '2',
            centerGroupId: 0,
            title: 'Point S lanza programa de formación digital',
            description: 'Nueva plataforma de formación online disponible para todos los talleres asociados. Incluye cursos sobre nuevas tecnologías, atención al cliente y gestión empresarial.',
            creationDate: new Date('2025-01-15'),
            viewFileUri: 'https://images.pexels.com/photos/3739327/pexels-photo-3739327.jpeg',
            viewFileType: 0,
            isPublished: true,
            // Campos de retrocompatibilidad
            publicationDate: new Date('2025-01-15'),
            attachmentUrl: 'https://images.pexels.com/photos/3739327/pexels-photo-3739327.jpeg',
            createdAt: new Date('2025-01-12'),
            updatedAt: new Date('2025-01-15')
        },
        {
            id: '3',
            centerGroupId: 0,
            title: 'Resultados del primer trimestre 2025',
            description: 'Análisis de los resultados comerciales del primer trimestre del año. Datos de ventas, nuevas incorporaciones y proyecciones para el segundo trimestre.',
            creationDate: new Date('2025-01-25'),
            previewFileUri: 'https://www.point-s-group.com/wp-content/themes/points/images/logo.png',
            viewFileUri: 'https://www.infotaller.tv/neumaticos/point-s-alcanza-los-50-talleres-en-espana.html',
            viewFileType: 0,
            isPublished: false,
            // Campos de retrocompatibilidad
            publicationDate: new Date('2025-01-25'),
            thumbnailUrl: 'https://www.point-s-group.com/wp-content/themes/points/images/logo.png',
            attachmentUrl: 'https://www.infotaller.tv/neumaticos/point-s-alcanza-los-50-talleres-en-espana.html',
            createdAt: new Date('2025-01-23'),
            updatedAt: new Date('2025-01-24')
        }
    ];

    // private mockMaterialTypes: MaterialType[] = [
    //     {
    //         id: '1',
    //         centerId: 0,
    //         name: 'Material Promocional',
    //         subcategories: [
    //             { id: 1, name: 'Folletos', materialTypeId: 1 },
    //             { id: 2, name: 'Carteles', materialTypeId: 1 },
    //             { id: 3, name: 'Banners', materialTypeId: 1 }
    //         ],
    //         createdAt: new Date('2025-01-01'),
    //         updatedAt: new Date('2025-01-15')
    //     },
    //     {
    //         id: '2',
    //         centerId: 0,
    //         name: 'Uniformes y Textil',
    //         subcategories: [
    //             { id: 4, name: 'Camisetas', materialTypeId: 2 },
    //             { id: 5, name: 'Chalecos', materialTypeId: 2 },
    //             { id: 6, name: 'Gorras', materialTypeId: 2 }
    //         ],
    //         createdAt: new Date('2025-01-01'),
    //         updatedAt: new Date('2025-01-10')
    //     },
    //     {
    //         id: '3',
    //         centerId: 0,
    //         name: 'Herramientas y Equipos',
    //         subcategories: [
    //             { id: 7, name: 'Herramientas básicas', materialTypeId: 3 },
    //             { id: 8, name: 'Equipos de diagnóstico', materialTypeId: 3 },
    //             { id: 9, name: 'Accesorios', materialTypeId: 3 }
    //         ],
    //         createdAt: new Date('2025-01-05'),
    //         updatedAt: new Date('2025-01-20')
    //     }
    // ];

    // private mockSuggestionTypes: SuggestionType[] = [
    //     {
    //         id: '1',
    //         name: 'Mejoras en la plataforma',
    //         displayOrder: 1,
    //         createdAt: new Date('2025-01-01'),
    //         updatedAt: new Date('2025-01-01')
    //     },
    //     {
    //         id: '2',
    //         name: 'Nuevos productos o servicios',
    //         displayOrder: 2,
    //         createdAt: new Date('2025-01-01'),
    //         updatedAt: new Date('2025-01-01')
    //     },
    //     {
    //         id: '3',
    //         name: 'Formación y capacitación',
    //         displayOrder: 3,
    //         createdAt: new Date('2025-01-01'),
    //         updatedAt: new Date('2025-01-01')
    //     },
    //     {
    //         id: '4',
    //         name: 'Soporte técnico',
    //         displayOrder: 4,
    //         createdAt: new Date('2025-01-01'),
    //         updatedAt: new Date('2025-01-01')
    //     },
    //     {
    //         id: '5',
    //         name: 'Otros',
    //         displayOrder: 5,
    //         createdAt: new Date('2025-01-01'),
    //         updatedAt: new Date('2025-01-01')
    //     }
    // ];

    private mockDocumentation: Documentation[] = [
        {
            id: "1",
            documentTitle: 'Manual de instalación de neumáticos',
            documentDescription: 'Guía completa para la instalación correcta de neumáticos en diferentes tipos de vehículos',
            publicLink: 'https://example.com/manual-neumaticos.pdf',
            documentCategory: 'workshop-guides',
            isExternalLink: true,
            isDraft: false
        },
        {
            id: "2",
            documentTitle: 'Procedimientos de taller - Cambio de aceite',
            documentDescription: 'Procedimientos paso a paso para el cambio de aceite y filtros',
            publicLink: 'https://example.com/cambio-aceite.pdf',
            documentCategory: 'workshop-guides',
            isExternalLink: true,
            isDraft: false
        },
        {
            id: "3",
            documentTitle: 'Tutorial mantenimiento frenos',
            documentDescription: 'Tutorial en video sobre mantenimiento y cambio de pastillas de freno',
            publicLink: 'https://youtube.com/watch?v=example',
            documentCategory: 'trainings',
            isExternalLink: true,
            isDraft: true
        },
        {
            id: "4",
            documentTitle: 'Video promocional productos verano',
            documentDescription: 'Video promocional de los productos para la temporada de verano',
            publicLink: 'https://youtube.com/watch?v=promocional-verano',
            documentCategory: 'promotional-videos',
            isExternalLink: true,
            isDraft: false
        }
    ];

    private mockCampaignEntries: CampaignEntry[] = [
        {
            id: 1,
            product: 'Neumático Michelin Pilot Sport 4',
            brand: 'Michelin',
            distributor: 'Distribuidor A',
            minimumTires: 4,
            points: 100,
            workshopType: WorkshopType.POINT_S,
            tireSizes: []
        },
        {
            id: 2,
            product: 'Neumático Continental PremiumContact 6',
            brand: 'Continental',
            distributor: 'Distribuidor B',
            minimumTires: 4,
            points: 120,
            workshopType: WorkshopType.POINT_S,
            tireSizes: []
        },
        {
            id: 3,
            product: 'Neumático Bridgestone Turanza T005',
            brand: 'Bridgestone',
            distributor: 'Distribuidor C',
            minimumTires: 6,
            points: 150,
            workshopType: WorkshopType.POINT_S_EXPRESS,
            tireSizes: []
        },
        {
            id: 4,
            product: 'Neumático Pirelli Cinturato P7',
            brand: 'Pirelli',
            distributor: 'Distribuidor A',
            minimumTires: 8,
            points: 200,
            workshopType: WorkshopType.POINT_S_EXPRESS,
            tireSizes: []
        }
    ];

    private promotionApiUrl = `${environment.cafler_backoffice_back_url}/Promotions`;
    private newsApiUrl = `${environment.cafler_backoffice_back_url}/News`;

    constructor(
        private http: HttpClient,
        private authService: AuthService,
        private userRoleService: UserRoleService,
        private mockDataService: MockDataService
    ) { }

    /**
     * Crea una imagen placeholder de 1x1 pixel transparente
     * para enviar cuando no queremos cambiar la imagen existente
     */
    private createPlaceholderImage(): Blob {
        // Crear un PNG de 1x1 pixel transparente válido
        const transparentPixel = new Uint8Array([
            0x89, 0x50, 0x4E, 0x47, 0x0D, 0x0A, 0x1A, 0x0A, // PNG signature
            0x00, 0x00, 0x00, 0x0D, 0x49, 0x48, 0x44, 0x52, // IHDR chunk
            0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x01, // 1x1 dimensions
            0x08, 0x06, 0x00, 0x00, 0x00, 0x1F, 0x15, 0xC4, // bit depth, color type, etc.
            0x89, 0x00, 0x00, 0x00, 0x0A, 0x49, 0x44, 0x41, // IDAT chunk
            0x54, 0x78, 0x9C, 0x63, 0x00, 0x01, 0x00, 0x00, // compressed data
            0x05, 0x00, 0x01, 0x0D, 0x0A, 0x2D, 0xB4, 0x00, // end of IDAT
            0x00, 0x00, 0x00, 0x49, 0x45, 0x4E, 0x44, 0xAE, // IEND chunk
            0x42, 0x60, 0x82
        ]);

        return new Blob([transparentPixel], { type: 'image/png' });
    }

    // Banner methods
    // getBannersFake(): Observable<Banner[]> {
    //     return of([...this.mockBanners]).pipe(delay(500));
    // }

    // Banner methods
    getBanners(onlyPublished: boolean = false): Observable<Banner[]> {
        return from(this.authService.getAccessToken()).pipe(
            switchMap((token) => {
                if (!token) {
                    throw new Error('No token available');
                }

                return this.http.get<Banner[]>(`${this.promotionApiUrl}?onlyPublished=${onlyPublished}`, {
                    headers: {
                        Authorization: 'Bearer ' + token,
                    }
                });
            })
        );
    }

    createBanner(banner: Banner): Observable<Banner> {
        return from(this.authService.getAccessToken()).pipe(
            switchMap((token) => {
                if (!token) {
                    throw new Error('No token available');
                }

                // Crear FormData para multipart/form-data
                const formData = new FormData();

                // Agregar campos requeridos según el cURL
                formData.append('Title', banner.title || '');
                formData.append('IsPublished', banner.isPublished.toString());
                formData.append('Position', banner.position.toString());
                formData.append('CenterGroupId', banner.centerGroupId!.toString());
                formData.append('ViewFileType', banner.viewFileType.toString());

                formData.append('StartDate', banner.startDate || new Date().toISOString());
                formData.append('ExpirationDate', banner.expirationDate || new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString());

                if (banner.imageFile) {
                    formData.append('ViewFile', banner.imageFile, banner.imageFile.name);
                }
                if (banner.thumbnailFile) {
                    formData.append('PreviewPicture', banner.thumbnailFile, banner.thumbnailFile.name);
                }

                return this.http.post<Banner>(this.promotionApiUrl, formData, {
                    headers: {
                        Authorization: 'Bearer ' + token,
                    }
                });
            })
        );
    }

    updateBanner(id: string, banner: Banner): Observable<Banner> {
        return from(this.authService.getAccessToken()).pipe(
            switchMap((token) => {
                if (!token) {
                    throw new Error('No token available');
                }

                const formData = new FormData();

                formData.append('Title', banner.title || '');
                formData.append('IsPublished', banner.isPublished.toString());
                formData.append('Position', banner.position.toString());
                formData.append('ViewFileType', banner.viewFileType.toString());

                formData.append('StartDate', banner.startDate || new Date().toISOString());
                formData.append('ExpirationDate', banner.expirationDate || new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString());

                if (banner.imageFile) {
                    formData.append('ViewFile', banner.imageFile, banner.imageFile.name);
                }

                if (banner.thumbnailFile) {
                    formData.append('PreviewPicture', banner.thumbnailFile, banner.thumbnailFile.name);
                }

                return this.http.put<Banner>(`${this.promotionApiUrl}/${id}`, formData, {
                    headers: {
                        Authorization: 'Bearer ' + token,
                    }
                });
            })
        );
    }

    deleteBanner(id: string): Observable<void> {
        return from(this.authService.getAccessToken()).pipe(
            switchMap((token) => {
                if (!token) {
                    throw new Error('No token available');
                }
                return this.http.delete<void>(`${this.promotionApiUrl}/${id}`, {
                    headers: {
                        Authorization: 'Bearer ' + token,
                    }
                });
            })
        );
    }

    getNews(onlyPublished: boolean = false): Observable<News[]> {
        return from(this.authService.getAccessToken()).pipe(
            switchMap(token => {
                if (!token) {
                    return throwError(() => new Error('No authentication token available'));
                }
                const url = `${this.newsApiUrl}?onlyPublished=${onlyPublished}`;
                return this.http.get<NewsApiResponse[]>(url, {
                    headers: {
                        Authorization: 'Bearer ' + token,
                    }
                });
            }),
            map((newsArray: NewsApiResponse[]) => newsArray.map(newsItem => this.mapApiResponseToNews(newsItem)))
        );
    }

    createNews(news: News): Observable<News> {
        return from(this.userRoleService.getCurrentUser()).pipe(
            switchMap(user => {
                const userCenterGroupId = user?.centerGroupId || 0;

                return from(this.authService.getAccessToken()).pipe(
                    switchMap(token => {
                        if (!token) {
                            return throwError(() => new Error('No authentication token available'));
                        }
                        const formData = this.prepareNewsFormData(news, userCenterGroupId);

                        return this.http.post<NewsApiResponse>(`${this.newsApiUrl}`, formData, {
                            headers: {
                                'Authorization': 'Bearer ' + token
                            }
                        });
                    })
                );
            }),
            map((newsResponse: NewsApiResponse) => this.mapApiResponseToNews(newsResponse))
        );
    }

    updateNews(id: string, news: News): Observable<News> {
        return from(this.userRoleService.getCurrentUser()).pipe(
            switchMap(user => {
                const userCenterGroupId = user?.centerGroupId || 0;

                return from(this.authService.getAccessToken()).pipe(
                    switchMap(token => {
                        if (!token) {
                            return throwError(() => new Error('No authentication token available'));
                        }
                        const formData = this.prepareNewsUpdateFormData(news);

                        return this.http.put<NewsApiResponse>(`${this.newsApiUrl}/${id}`, formData, {
                            headers: {
                                'Authorization': 'Bearer ' + token
                            }
                        });
                    })
                );
            }),
            map((newsResponse: NewsApiResponse) => this.mapApiResponseToNews(newsResponse))
        );
    }

    deleteNews(id: string): Observable<void> {
        return from(this.authService.getAccessToken()).pipe(
            switchMap(token => {
                if (!token) {
                    return throwError(() => new Error('No authentication token available'));
                }
                return this.http.delete<void>(`${this.newsApiUrl}/${id}`, {
                    headers: {
                        Authorization: 'Bearer ' + token,
                    }
                });
            })
        );
    }

    private mapApiResponseToNews(apiResponse: NewsApiResponse): News {
        return {
            id: apiResponse.id,
            centerGroupId: apiResponse.centerGroupId,
            title: apiResponse.title,
            description: apiResponse.description,
            creationDate: new Date(apiResponse.creationDate),
            previewFileName: apiResponse.previewFileName,
            previewFileUri: apiResponse.previewFileUri,
            viewFileName: apiResponse.viewFileName,
            viewFileUri: apiResponse.viewFileUri,
            viewFileType: apiResponse.viewFileType,
            isPublished: apiResponse.isPublished,
            publicationDate: new Date(apiResponse.creationDate),
            thumbnailUrl: apiResponse.previewFileUri,
            attachmentUrl: apiResponse.viewFileUri || apiResponse.viewUrl,
            createdAt: new Date(apiResponse.creationDate),
            updatedAt: new Date(apiResponse.creationDate)
        };
    }

    private inferViewFileType(news: News): number {
        if (news.attachmentUrl && (news.attachmentUrl.startsWith('http://') || news.attachmentUrl.startsWith('https://'))) {
            return 2;
        }

        if (news.attachmentFile) {
            const mimeType = news.attachmentFile.type.toLowerCase();
            const fileName = news.attachmentFile.name.toLowerCase();

            if (mimeType === 'application/pdf' || fileName.endsWith('.pdf')) {
                return 0;
            }

            if (mimeType.startsWith('image/')) {
                return 1;
            }

            if (fileName.endsWith('.pdf')) return 0;
            if (fileName.endsWith('.jpg') || fileName.endsWith('.jpeg') ||
                fileName.endsWith('.png') || fileName.endsWith('.gif') ||
                fileName.endsWith('.webp')) {
                return 1;
            }
        }

        return 1;
    }

    private prepareNewsFormData(news: News, centerGroupId: number): FormData {
        const formData = new FormData();

        // Campos requeridos según el curl
        formData.append('Title', news.title || '');
        formData.append('Description', news.description || '');
        formData.append('CreationDate', news.creationDate.toISOString());
        formData.append('IsPublished', news.isPublished.toString());
        formData.append('CenterGroupId', centerGroupId.toString());
        formData.append('ViewFileType', this.inferViewFileType(news).toString());

        // Archivos
        if (news.thumbnailFile) {
            formData.append('PreviewPicture', news.thumbnailFile);
        } else {
            formData.append('PreviewPicture', ''); // Campo vacío según el curl
        }

        if (news.attachmentFile) {
            formData.append('ViewFile', news.attachmentFile);
        } else {
            formData.append('ViewFile', ''); // Campo vacío según el curl
        }

        // URL externa si existe
        if (news.attachmentUrl && (news.attachmentUrl.startsWith('http://') || news.attachmentUrl.startsWith('https://'))) {
            formData.append('ViewUrl', news.attachmentUrl);
        } else {
            formData.append('ViewUrl', 'string'); // Valor por defecto según el curl
        }

        return formData;
    }

    /**
     * Prepara FormData para el UPDATE de noticias según el formato multipart/form-data
     * Nota: El UPDATE no incluye CreationDate ni CenterId
     * Si no hay archivos nuevos, se envía null para indicar al backend que no se cambian
     */
    private prepareNewsUpdateFormData(news: News): FormData {
        const formData = new FormData();

        // Campos para UPDATE según el curl (sin CreationDate ni CenterId)
        formData.append('Title', news.title || '');
        formData.append('Description', news.description || '');
        formData.append('IsPublished', news.isPublished.toString());
        formData.append('ViewFileType', this.inferViewFileType(news).toString());

        // Archivos - enviar null si no hay archivos nuevos para que el backend no los cambie
        if (news.thumbnailFile) {
            // Hay un archivo nuevo para la imagen de preview
            formData.append('PreviewPicture', news.thumbnailFile);
        } else {
            // No hay archivo nuevo, enviar null para mantener el existente
            formData.append('PreviewPicture', 'null');
        }

        if (news.attachmentFile) {
            // Hay un archivo nuevo adjunto
            formData.append('ViewFile', news.attachmentFile);
        } else {
            // No hay archivo nuevo, enviar null para mantener el existente
            formData.append('ViewFile', 'null');
        }

        // URL externa si existe
        if (news.attachmentUrl && (news.attachmentUrl.startsWith('http://') || news.attachmentUrl.startsWith('https://'))) {
            formData.append('ViewUrl', news.attachmentUrl);
        } else {
            formData.append('ViewUrl', 'string'); // Valor por defecto según el curl
        }

        return formData;
    }

    /**
     * Prepara el payload para la API convirtiendo archivos a base64
     * @deprecated Este método ya no se usa, mantenido para compatibilidad
     */
    private prepareNewsPayload(news: News, centerId: number): Observable<any> {
        const isExternalUrl = news.attachmentUrl && (news.attachmentUrl.startsWith('http://') || news.attachmentUrl.startsWith('https://'));

        const basePayload = {
            centerId: centerId,
            title: news.title,
            description: news.description,
            creationDate: news.creationDate.toISOString(),
            previewPicture: null as string | null,
            viewFile: null as string | null,
            viewUrl: isExternalUrl ? news.attachmentUrl : null,
            viewFileType: this.inferViewFileType(news),
            isPublished: news.isPublished
        };

        // Si no hay archivos, devolver el payload directamente
        if (!news.thumbnailFile && !news.attachmentFile) {
            return of(basePayload);
        }

        // Convertir archivos a base64 secuencialmente
        let result$ = of(basePayload);

        if (news.thumbnailFile) {
            result$ = result$.pipe(
                switchMap(payload =>
                    this.fileToBase64(news.thumbnailFile!).pipe(
                        map(base64 => ({
                            ...payload,
                            previewPicture: base64
                        }))
                    )
                )
            );
        }

        if (news.attachmentFile) {
            result$ = result$.pipe(
                switchMap(payload =>
                    this.fileToBase64(news.attachmentFile!).pipe(
                        map(base64 => ({
                            ...payload,
                            viewFile: base64
                        }))
                    )
                )
            );
        }

        return result$;
    }

    /**
     * Convierte un archivo a base64
     */
    private fileToBase64(file: File): Observable<string> {
        return new Observable(observer => {
            const reader = new FileReader();
            reader.onload = () => {
                const result = reader.result as string;
                // Remover el prefijo "data:tipo/subtipo;base64," para obtener solo el base64
                const base64 = result.split(',')[1];
                observer.next(base64);
                observer.complete();
            };
            reader.onerror = (error) => observer.error(error);
            reader.readAsDataURL(file);
        });
    }

    // Material types methods
    getMaterialTypes(): Observable<MaterialType[]> {
        return from(this.authService.getAccessToken()).pipe(
            switchMap(token => {
                if (!token) {
                    return throwError(() => new Error('No authentication token available'));
                }

                const url = `${environment.cafler_backoffice_back_url}/material-types`;
                return this.http.get<MaterialTypeApiResponse[]>(url, {
                    headers: {
                        Authorization: 'Bearer ' + token,
                    }
                });
            }),
            map((materialTypesArray: MaterialTypeApiResponse[]) =>
                materialTypesArray.map(materialType => this.mapApiResponseToMaterialType(materialType))
            )
        );
    }

    createMaterialType(type: MaterialType): Observable<MaterialType> {
        return from(this.userRoleService.getCurrentUser()).pipe(
            switchMap(user => {
                const userCenterGroupId = user?.centerGroupId || 0;

                return from(this.authService.getAccessToken()).pipe(
                    switchMap(token => {
                        if (!token) {
                            return throwError(() => new Error('No authentication token available'));
                        }

                        const createRequest: MaterialTypeCreateRequest = {
                            centerGroupId: userCenterGroupId,
                            name: type.name,
                            subCategories: type.subcategories.map(sub => sub.name)
                        };

                        return this.http.post<MaterialTypeApiResponse>(`${environment.cafler_backoffice_back_url}/material-types`, createRequest, {
                            headers: {
                                'Authorization': 'Bearer ' + token,
                                'Content-Type': 'application/json'
                            }
                        });
                    })
                );
            }),
            map((materialTypeResponse: MaterialTypeApiResponse) => this.mapApiResponseToMaterialType(materialTypeResponse))
        );
    }

    updateMaterialType(id: string, type: MaterialType): Observable<MaterialType> {
        return from(this.userRoleService.getCurrentUser()).pipe(
            switchMap(user => {
                const userCenterGroupId = user?.centerGroupId || 0;

                return from(this.authService.getAccessToken()).pipe(
                    switchMap(token => {
                        if (!token) {
                            return throwError(() => new Error('No authentication token available'));
                        }

                        const updateRequest: MaterialTypeUpdateRequest = {
                            id: id,
                            centerGroupId: userCenterGroupId,
                            name: type.name,
                            subCategories: type.subcategories.map(sub => sub.name)
                        };

                        return this.http.put<MaterialTypeApiResponse>(`${environment.cafler_backoffice_back_url}/material-types`, updateRequest, {
                            headers: {
                                'Authorization': 'Bearer ' + token,
                                'Content-Type': 'application/json'
                            }
                        });
                    })
                );
            }),
            map((materialTypeResponse: MaterialTypeApiResponse) => this.mapApiResponseToMaterialType(materialTypeResponse))
        );
    }

    deleteMaterialType(id: string): Observable<void> {
        return from(this.authService.getAccessToken()).pipe(
            switchMap(token => {
                if (!token) {
                    return throwError(() => new Error('No authentication token available'));
                }
                return this.http.delete<void>(`${environment.cafler_backoffice_back_url}/material-types/${id}`, {
                    headers: {
                        Authorization: 'Bearer ' + token,
                    }
                });
            })
        );
    }

    // Helper method to map API response to MaterialType interface
    private mapApiResponseToMaterialType(apiResponse: MaterialTypeApiResponse): MaterialType {
        return {
            id: apiResponse.id,
            centerGroupId: apiResponse.centerGroupId,
            name: apiResponse.name,
            subcategories: apiResponse.subCategories.map((subCatName, index) => ({
                id: index + 1, // Generar IDs secuenciales para las subcategorías
                name: subCatName,
                materialTypeId: 0 // No se usa en el frontend
            })),
            createdAt: new Date(),
            updatedAt: new Date()
        };
    }

    // Suggestion types methods
    getSuggestionTypes(): Observable<SuggestionType[]> {
        return from(this.authService.getAccessToken()).pipe(
            switchMap(token => {
                if (!token) {
                    return throwError(() => new Error('No authentication token available'));
                }

                const url = `${environment.cafler_backoffice_back_url}/suggestion-types`;
                return this.http.get<SuggestionTypeApiResponse[]>(url, {
                    headers: {
                        Authorization: 'Bearer ' + token,
                    }
                });
            }),
            map((suggestionTypesArray: SuggestionTypeApiResponse[]) =>
                suggestionTypesArray.map(suggestionType => this.mapApiResponseToSuggestionType(suggestionType))
            )
        );
    }

    createSuggestionType(type: SuggestionType): Observable<SuggestionType> {
        return from(this.userRoleService.getCurrentUser()).pipe(
            switchMap(user => {
                const userCenterGroupId = user?.centerGroupId || 0;

                return from(this.authService.getAccessToken()).pipe(
                    switchMap(token => {
                        if (!token) {
                            return throwError(() => new Error('No authentication token available'));
                        }

                        const createRequest: SuggestionTypeRequest = {
                            id: crypto.randomUUID(), // Generar un nuevo UUID
                            title: type.name,
                            centerGroupId: userCenterGroupId
                        };

                        return this.http.post<SuggestionTypeApiResponse>(`${environment.cafler_backoffice_back_url}/suggestion-types`, createRequest, {
                            headers: {
                                'Authorization': 'Bearer ' + token,
                                'Content-Type': 'application/json'
                            }
                        });
                    })
                );
            }),
            map((suggestionTypeResponse: SuggestionTypeApiResponse) => this.mapApiResponseToSuggestionType(suggestionTypeResponse))
        );
    }

    updateSuggestionType(id: string, type: SuggestionType): Observable<SuggestionType> {
        return from(this.userRoleService.getCurrentUser()).pipe(
            switchMap(user => {
                const userCenterGroupId = user?.centerGroupId || 0;

                return from(this.authService.getAccessToken()).pipe(
                    switchMap(token => {
                        if (!token) {
                            return throwError(() => new Error('No authentication token available'));
                        }

                        const updateRequest: SuggestionTypeRequest = {
                            id: id,
                            title: type.name,
                            centerGroupId: userCenterGroupId
                        };

                        return this.http.put<SuggestionTypeApiResponse>(`${environment.cafler_backoffice_back_url}/suggestion-types`, updateRequest, {
                            headers: {
                                'Authorization': 'Bearer ' + token,
                                'Content-Type': 'application/json'
                            }
                        });
                    })
                );
            }),
            map((suggestionTypeResponse: SuggestionTypeApiResponse) => this.mapApiResponseToSuggestionType(suggestionTypeResponse))
        );
    }

    deleteSuggestionType(id: string): Observable<void> {
        return from(this.authService.getAccessToken()).pipe(
            switchMap(token => {
                if (!token) {
                    return throwError(() => new Error('No authentication token available'));
                }
                return this.http.delete<void>(`${environment.cafler_backoffice_back_url}/suggestion-types/${id}`, {
                    headers: {
                        Authorization: 'Bearer ' + token,
                    }
                });
            })
        );
    }

    submitSuggestion(suggestionData: {
        fullName: string;
        email: string;
        suggestionTypeId: string;
        additionalComments: string;
    }): Observable<any> {
        return from(this.authService.getAccessToken()).pipe(
            switchMap(token => {
                if (!token) {
                    return throwError(() => new Error('No authentication token available'));
                }
                return this.http.post<any>(`${environment.cafler_backoffice_back_url}/requests/suggestion`, suggestionData, {
                    headers: {
                        Authorization: 'Bearer ' + token,
                        'Content-Type': 'application/json'
                    }
                });
            })
        );
    }

    submitMaterialRequest(materialData: {
        fullName: string;
        email: string;
        materialTypeId: string;
        additionalComments: string;
    }): Observable<any> {
        return from(this.authService.getAccessToken()).pipe(
            switchMap(token => {
                if (!token) {
                    return throwError(() => new Error('No authentication token available'));
                }
                return this.http.post<any>(`${environment.cafler_backoffice_back_url}/requests/material`, materialData, {
                    headers: {
                        Authorization: 'Bearer ' + token,
                        'Content-Type': 'application/json'
                    }
                });
            })
        );
    }

    // Helper method to map API response to SuggestionType interface
    private mapApiResponseToSuggestionType(apiResponse: SuggestionTypeApiResponse): SuggestionType {
        return {
            id: apiResponse.id,
            name: apiResponse.title,
            centerGroupId: apiResponse.centerGroupId,
            displayOrder: 1, // Valor por defecto
            createdAt: new Date(),
            updatedAt: new Date()
        };
    }

    // Documentation methods
    getDocumentation(): Observable<Documentation[]> {
        return from(this.authService.getAccessToken()).pipe(
            switchMap(token => {
                if (!token) {
                    return throwError(() => new Error('No authentication token available'));
                }
                return this.http.get<Documentation[]>(`${environment.cafler_backoffice_back_url}/users/document`, {
                    headers: {
                        Authorization: 'Bearer ' + token,
                    }
                });
            })
        );
    }

    getDocumentationCategories(): Observable<string[]> {
        return of(['trainings', 'workshop-guides', 'promotional-videos']).pipe(delay(200));
    }

    createDocumentation(formData: FormData): Observable<Documentation> {
        return from(this.authService.getAccessToken()).pipe(
            switchMap(token => {
                if (!token) {
                    return throwError(() => new Error('No authentication token available'));
                }
                return this.http.post<Documentation>(`${environment.cafler_backoffice_back_url}/users/document`, formData, {
                    headers: {
                        Authorization: 'Bearer ' + token,
                    }
                });
            })
        );
    }

    updateDocumentation(id: string, formData: FormData): Observable<Documentation> {
        return from(this.authService.getAccessToken()).pipe(
            switchMap(token => {
                if (!token) {
                    return throwError(() => new Error('No authentication token available'));
                }
                return this.http.put<Documentation>(`${environment.cafler_backoffice_back_url}/users/document/${id}`, formData, {
                    headers: {
                        Authorization: 'Bearer ' + token,
                    }
                });
            })
        );
    }

    deleteDocumentation(id: string): Observable<void> {
        return from(this.authService.getAccessToken()).pipe(
            switchMap(token => {
                if (!token) {
                    return throwError(() => new Error('No authentication token available'));
                }
                return this.http.delete<void>(`${environment.cafler_backoffice_back_url}/users/document/${id}`, {
                    headers: {
                        Authorization: 'Bearer ' + token,
                    }
                });
            })
        );
    }

    // Campaign methods
    getCampaignEntries(): Observable<CampaignEntry[]> {
        return of([...this.mockCampaignEntries]).pipe(delay(500));
    }

    createCampaignEntry(entry: CampaignEntry): Observable<CampaignEntry> {
        const newEntry: CampaignEntry = {
            ...entry,
            id: Math.max(...this.mockCampaignEntries.map(e => e.id || 0)) + 1
        };
        this.mockCampaignEntries.push(newEntry);
        return of(newEntry).pipe(delay(500));
    }

    updateCampaignEntry(id: number, entry: CampaignEntry): Observable<CampaignEntry> {
        const index = this.mockCampaignEntries.findIndex(e => e.id === id);
        if (index === -1) {
            return throwError(() => new Error('Campaign entry not found'));
        }

        const updatedEntry: CampaignEntry = {
            ...this.mockCampaignEntries[index],
            ...entry,
            id
        };
        this.mockCampaignEntries[index] = updatedEntry;
        return of(updatedEntry).pipe(delay(500));
    }

    deleteCampaignEntry(id: number): Observable<void> {
        const index = this.mockCampaignEntries.findIndex(e => e.id === id);
        if (index === -1) {
            return throwError(() => new Error('Campaign entry not found'));
        }

        this.mockCampaignEntries.splice(index, 1);
        return of(void 0).pipe(delay(500));
    }

    // Email Configuration (mock data)
    private mockEmailConfiguration: EmailConfiguration = {
        materialRequestEmail: 'material@empresa.com',
        suggestionEmail: 'sugerencias@empresa.com',
        createdAt: new Date('2025-01-01'),
        updatedAt: new Date('2025-01-15')
    };

    // Email Configuration methods
    getEmailConfiguration(): Observable<EmailConfiguration> {
        return of({ ...this.mockEmailConfiguration }).pipe(delay(500));
    }

    updateEmailConfiguration(config: EmailConfiguration): Observable<EmailConfiguration> {
        this.mockEmailConfiguration = {
            ...this.mockEmailConfiguration,
            ...config,
            updatedAt: new Date()
        };
        return of({ ...this.mockEmailConfiguration }).pipe(delay(500));
    }

    // Email Notifications methods
    getEmailNotifications(centerGroupId: number): Observable<EmailNotification[]> {
        return from(this.getAuthHeaders()).pipe(
            switchMap(headers => {
                const url = `${environment.cafler_backoffice_back_url}/CenterGroups/notifications/email`;
                return this.http.get<EmailNotification[]>(url, { headers });
            }),
            map(notifications => notifications || [])
        );
    }

    updateEmailNotification(centerGroupId: number, notification: EmailNotificationRequest): Observable<EmailNotification> {
        return from(this.getAuthHeaders()).pipe(
            switchMap(headers => {
                const url = `${environment.cafler_backoffice_back_url}/CenterGroups/notifications/email`;
                return this.http.put<EmailNotification>(url, notification, { headers });
            })
        );
    }

    // Incentive Travel methods
    createIncentiveTravel(travelData: IncentiveTravel): Observable<IncentiveTravel> {
        if (this.useMockData) {
            return this.mockDataService.createIncentiveTravel(travelData);
        }

        return from(this.getAuthHeaders()).pipe(
            switchMap(headers => {
                const startDate = travelData.startDate instanceof Date
                    ? travelData.startDate
                    : new Date(travelData.startDate);
                const endDate = travelData.endDate instanceof Date
                    ? travelData.endDate
                    : new Date(travelData.endDate);

                const body = {
                    title: travelData.title,
                    centerGroupId: travelData.centerGroupId || 0,
                    description: travelData.description,
                    destination: travelData.destination,
                    generalConditions: travelData.generalConditions,
                    isActive: travelData.isActive,
                    objectivePoints: travelData.objectivePoints,
                    pointsEarned: travelData.pointsEarned,
                    startDate: startDate.toISOString(),
                    endDate: endDate.toISOString(),
                    filesDto: travelData.filesDto?.map(file => ({
                        incentiveTravelId: "00000000-0000-0000-0000-000000000000", // Por ahora no se rellena según instrucciones
                        fileType: file.fileType,
                        fileName: file.fileName,
                        externalUrl: file.externalUrl || "",
                        fileBase64: file.fileBase64 || ""
                    })) || []
                };

                const url = `${environment.cafler_backoffice_back_url}/IncentiveTravel/create-travel`;
                return this.http.post<IncentiveTravel>(url, body, { headers });
            })
        );
    }

    // Obtener lista de viajes de incentivos
    getIncentiveTravels(): Observable<IncentiveTravel[]> {
        if (this.useMockData) {
            return this.mockDataService.getIncentiveTravels();
        }

        return from(this.getAuthHeaders()).pipe(
            switchMap(headers => {
                const url = `${environment.cafler_backoffice_back_url}/IncentiveTravel`;
                return this.http.get<IncentiveTravel[]>(url, { headers });
            })
        );
    }

    updateIncentiveTravel(id: number, travelData: IncentiveTravel): Observable<IncentiveTravel> {
        if (this.useMockData) {
            return this.mockDataService.updateIncentiveTravel(id, travelData);
        }

        return from(this.getAuthHeaders()).pipe(
            switchMap(headers => {
                // Preparar el body según la especificación del backend (similar a create)
                const body = {
                    title: travelData.title,
                    centerGroupId: travelData.centerGroupId || 0,
                    description: travelData.description,
                    destination: travelData.destination,
                    generalConditions: travelData.generalConditions,
                    isActive: travelData.isActive,
                    objectivePoints: travelData.objectivePoints,
                    pointsEarned: travelData.pointsEarned,
                    startDate: travelData.startDate.toISOString(),
                    endDate: travelData.endDate.toISOString(),
                    filesDto: travelData.filesDto?.map(file => ({
                        incentiveTravelId: "00000000-0000-0000-0000-000000000000", // Se actualizará en el backend
                        fileType: file.fileType,
                        fileName: file.fileName,
                        externalUrl: file.externalUrl || "",
                        fileBase64: file.fileBase64 || ""
                    })) || []
                };

                const url = `${environment.cafler_backoffice_back_url}/IncentiveTravel/incentive-travel/${id}`;
                return this.http.put<IncentiveTravel>(url, body, { headers });
            })
        );
    }

    updateIncentiveTravelWithFileManagement(id: number, updateData: IncentiveTravelUpdateData): Observable<IncentiveTravel> {
        if (this.useMockData) {
            const mockTravelData: IncentiveTravel = {
                id: id,
                title: updateData.title,
                description: updateData.description,
                destination: updateData.destination,
                generalConditions: updateData.generalConditions,
                isActive: updateData.isActive,
                objectivePoints: updateData.objectivePoints,
                pointsEarned: 0,
                startDate: new Date(updateData.startDate),
                endDate: new Date(updateData.endDate),
                filesDto: updateData.newFilesDto.map((file: NewIncentiveTravelFile) => ({
                    fileName: file.fileName,
                    fileType: file.fileType,
                    externalUrl: file.externalUrl,
                    fileBase64: file.fileBase64,
                    incentiveTravelId: file.incentiveTravelId
                }))
            };
            return this.mockDataService.updateIncentiveTravel(id, mockTravelData);
        }

        return from(this.getAuthHeaders()).pipe(
            switchMap(headers => {
                const url = `${environment.cafler_backoffice_back_url}/IncentiveTravel/incentive-travel/${id}`;
                return this.http.put<IncentiveTravel>(url, updateData, { headers });
            })
        );
    }

    deleteIncentiveTravel(travelId: number | string): Observable<void> {
        if (this.useMockData) {
            return this.mockDataService.deleteIncentiveTravel(Number(travelId));
        }

        return from(this.getAuthHeaders()).pipe(
            switchMap(headers => {
                const url = `${environment.cafler_backoffice_back_url}/IncentiveTravel/incentive-travel/${travelId}`;
                return this.http.delete<void>(url, { headers });
            })
        );
    }

    downloadIncentiveTravelFile(fileId: string): Observable<Blob> {
        if (this.useMockData) {
            return of(new Blob(['Mock file content'], { type: 'application/pdf' })).pipe(delay(300));
        }

        return from(this.getAuthHeaders()).pipe(
            switchMap(headers => {
                const url = `${environment.cafler_backoffice_back_url}/IncentiveTravel/file/${fileId}/download`;
                return this.http.get(url, {
                    headers,
                    responseType: 'blob'
                });
            })
        );
    }

    getIncentiveTravelProgress(): Observable<IncentiveTravelProgress> {
        if (this.useMockData) {
            return of({
                totalTravels: 3,
                activeTravels: 2,
                completedTravels: 1,
                totalPointsObjective: 45000,
                totalPointsEarned: 32500,
                progressPercentage: 72.2
            }).pipe(delay(300));
        }

        return from(this.getAuthHeaders()).pipe(
            switchMap(headers => {
                const url = `${environment.cafler_backoffice_back_url}/IncentiveTravel/progress`;
                return this.http.get<IncentiveTravelProgress>(url, { headers });
            })
        );
    }

    disableIncentiveTravel(travelId: number): Observable<void> {
        if (this.useMockData) {
            return this.mockDataService.deleteIncentiveTravel(travelId);
        }

        return from(this.getAuthHeaders()).pipe(
            switchMap(headers => {
                const url = `${environment.cafler_backoffice_back_url}/IncentiveTravel/incentive-travel/${travelId}/disable`;
                return this.http.put<void>(url, {}, { headers });
            })
        );
    }

    createIncentiveTravelRequirement(incentiveTravelId: string, requirementData: IncentiveTravelRequirementRequest): Observable<IncentiveTravelRequirement> {
        if (this.useMockData) {
            const mockRequirement: IncentiveTravelRequirement = {
                ...requirementData,
                centerGroupId: 1
            };
            return this.mockDataService.createIncentiveTravelRequirement(incentiveTravelId, mockRequirement);
        }

        return from(this.userRoleService.getCurrentUser()).pipe(
            switchMap(user => {
                const userCenterGroupId = user?.centerGroupId || 0;

                return from(this.getAuthHeaders()).pipe(
                    switchMap(headers => {
                        const body = {
                            providerId: requirementData.providerId,
                            productCategoryId: requirementData.productCategoryId,
                            minimumQuantity: requirementData.minimumQuantity,
                            brand: requirementData.brand,
                            centerGroupId: userCenterGroupId
                        };

                        const url = `${environment.cafler_backoffice_back_url}/IncentiveTravel/${incentiveTravelId}/create-requirement`;
                        return this.http.post<IncentiveTravelRequirement>(url, body, { headers });
                    })
                );
            })
        );
    }

    getProviders(): Observable<Provider[]> {
        if (this.useMockData) {
            return this.mockDataService.getProviders();
        }

        return from(this.getAuthHeaders()).pipe(
            switchMap(headers => {
                const url = `${environment.cafler_backoffice_back_url}/Providers`;
                return this.http.get<Provider[]>(url, { headers });
            })
        );
    }

    getIncentiveTravelRequirements(incentiveTravelId: string): Observable<IncentiveTravelRequirement[]> {
        if (this.useMockData) {
            return this.mockDataService.getIncentiveTravelRequirements(incentiveTravelId);
        }

        return from(this.getAuthHeaders()).pipe(
            switchMap(headers => {
                const url = `${environment.cafler_backoffice_back_url}/IncentiveTravel/travel-requirements`;
                return this.http.get<IncentiveTravelRequirementApiResponse[]>(url, { headers }).pipe(
                    map(apiRequirements => {
                        return apiRequirements.map(apiReq => this.mapApiResponseToRequirement(apiReq, incentiveTravelId));
                    })
                );
            })
        );
    }

    private mapApiResponseToRequirement(apiResponse: IncentiveTravelRequirementApiResponse, incentiveTravelId: string): IncentiveTravelRequirement {
        const simpleId = apiResponse.requirementId ?
            parseInt(apiResponse.requirementId.substring(0, 8), 16) :
            Math.floor(Math.random() * 1000000);

        const mapped = {
            id: simpleId,
            requirementId: apiResponse.requirementId,
            incentiveTravelId: incentiveTravelId,
            providerId: apiResponse.providerId || 0,
            productCategoryId: apiResponse.productCategoryId!,
            minimumQuantity: apiResponse.minimumQuantity,
            brand: apiResponse.brand,
            centerGroupId: apiResponse.centerGroupId
        };

        return mapped;
    }

    updateIncentiveTravelRequirement(requirementId: number | string, requirementData: IncentiveTravelRequirementRequest): Observable<IncentiveTravelRequirement> {
        if (this.useMockData) {
            const mockRequirement: IncentiveTravelRequirement = {
                ...requirementData,
                centerGroupId: 1
            };
            return this.mockDataService.updateIncentiveTravelRequirement(requirementId as number, mockRequirement);
        }

        return from(this.getAuthHeaders()).pipe(
            switchMap(headers => {
                const body = {
                    providerId: requirementData.providerId,
                    productCategoryId: requirementData.productCategoryId,
                    minimumQuantity: requirementData.minimumQuantity,
                    brand: requirementData.brand
                };

                const url = `${environment.cafler_backoffice_back_url}/IncentiveTravel/requirement/${requirementId}`;
                return this.http.put<IncentiveTravelRequirement>(url, body, { headers });
            })
        );
    }

    deleteIncentiveTravelRequirement(requirementId: number | string): Observable<void> {
        if (this.useMockData) {
            return this.mockDataService.deleteIncentiveTravelRequirement(requirementId as number);
        }

        return from(this.getAuthHeaders()).pipe(
            switchMap(headers => {
                const url = `${environment.cafler_backoffice_back_url}/IncentiveTravel/requirement/${requirementId}`;
                return this.http.delete<void>(url, { headers });
            })
        );
    }

    getIncentiveTravelPoints(campaignId: number): Observable<IncentiveTravelPointsResponse> {
        if (this.useMockData) {
            return this.mockDataService.getIncentiveTravelPoints(campaignId);
        }

        return from(this.getAuthHeaders()).pipe(
            switchMap(headers => {
                const url = `${environment.cafler_backoffice_back_url}/IncentiveTravel/travel-point-system-tyres`;
                return this.http.get<IncentiveTravelPointApiResponse[]>(url, { headers });
            }),
            map((apiResponse: IncentiveTravelPointApiResponse[]) => {
                const mappedPoints: IncentiveTravelPoint[] = apiResponse.map(point => ({
                    id: parseInt(point.pointsSystemTyresId.substring(0, 8), 16),
                    pointsSystemTyresId: point.pointsSystemTyresId,
                    providerId: 0,
                    providerName: point.providerName || undefined,
                    brand: point.brand,
                    minimumQuantity: point.minimumQuantity,
                    points: point.points,
                    rappelPlan: point.rappelPlan as RappelPlanType,
                    acceptedMeasures: point.acceptedMeasures,
                    centerGroupId: point.centerGroupId
                }));

                return {
                    points: mappedPoints,
                    total: mappedPoints.length,
                    page: 1,
                    limit: 50
                } as IncentiveTravelPointsResponse;
            })
        );
    }

    createIncentiveTravelPoint(incentiveTravelId: number, pointData: IncentiveTravelPointRequest): Observable<IncentiveTravelPoint> {
        if (this.useMockData) {
            return this.mockDataService.createIncentiveTravelPoint(incentiveTravelId, pointData);
        }

        return from(this.getAuthHeaders()).pipe(
            switchMap(headers => {
                const body = {
                    providerId: pointData.providerId,
                    brand: pointData.brand,
                    minimumQuantity: pointData.minimumQuantity,
                    points: pointData.points,
                    rappelPlan: pointData.rappelPlan,
                    acceptedMeasures: pointData.acceptedMeasures,
                    centerGroupId: pointData.centerGroupId
                };

                const url = `${environment.cafler_backoffice_back_url}/IncentiveTravel/${incentiveTravelId}/create-point-system`;
                return this.http.post<IncentiveTravelPoint>(url, body, { headers });
            })
        );
    }

    updateIncentiveTravelPoint(pointId: number | string, pointData: IncentiveTravelPointRequest): Observable<IncentiveTravelPoint> {
        if (this.useMockData) {
            return this.mockDataService.updateIncentiveTravelPoint(pointId as number, pointData);
        }

        return from(this.getAuthHeaders()).pipe(
            switchMap(headers => {
                const body = {
                    providerId: pointData.providerId,
                    brand: pointData.brand,
                    minimumQuantity: pointData.minimumQuantity,
                    points: pointData.points,
                    rappelPlan: pointData.rappelPlan,
                    acceptedMeasures: pointData.acceptedMeasures,
                    centerGroupId: pointData.centerGroupId
                };

                const url = `${environment.cafler_backoffice_back_url}/IncentiveTravel/points-system/tyres/${pointId}`;
                return this.http.put<IncentiveTravelPoint>(url, body, { headers });
            })
        );
    }

    deleteIncentiveTravelPoint(pointId: number | string): Observable<void> {
        if (this.useMockData) {
            return this.mockDataService.deleteIncentiveTravelPoint(pointId as number);
        }

        return from(this.getAuthHeaders()).pipe(
            switchMap(headers => {
                const url = `${environment.cafler_backoffice_back_url}/IncentiveTravel/points-system/tyres/${pointId}`;
                return this.http.delete<void>(url, { headers });
            })
        );
    }

    getSmtpConfig(): Observable<SmtpConfig | null> {
        return from(this.getAuthHeaders()).pipe(
            switchMap(headers => {
                const url = `${environment.cafler_backoffice_back_url}/v1/center-groups/notification-channels/smtp`;
                return this.http.get<SmtpConfig>(url, { headers });
            })
        );
    }

    createSmtpConfig(config: SmtpCreateRequest): Observable<SmtpConfig> {
        return from(this.getAuthHeaders()).pipe(
            switchMap(headers => {
                const url = `${environment.cafler_backoffice_back_url}/v1/center-groups/notification-channels/smtp`;
                return this.http.post<SmtpConfig>(url, config, { headers });
            })
        );
    }

    updateSmtpConfig(config: SmtpUpdateRequest): Observable<SmtpConfig> {
        return from(this.getAuthHeaders()).pipe(
            switchMap(headers => {
                const url = `${environment.cafler_backoffice_back_url}/v1/center-groups/notification-channels/smtp`;
                return this.http.put<SmtpConfig>(url, config, { headers });
            })
        );
    }

    deleteSmtpConfig(): Observable<void> {
        return from(this.getAuthHeaders()).pipe(
            switchMap(headers => {
                const url = `${environment.cafler_backoffice_back_url}/v1/center-groups/notification-channels/smtp`;
                return this.http.delete<void>(url, { headers });
            })
        );
    }

    testSmtpConnection(request: SmtpTestRequest): Observable<SmtpTestResponse> {
        return from(this.getAuthHeaders()).pipe(
            switchMap(headers => {
                const url = `${environment.cafler_backoffice_back_url}/v1/center-groups/notification-channels/smtp/test`;
                return this.http.post<SmtpTestResponse>(url, request, { headers });
            })
        );
    }

    getWhatsAppConfig(): Observable<WhatsAppConfig | null> {
        return from(this.getAuthHeaders()).pipe(
            switchMap(headers => {
                const url = `${environment.cafler_backoffice_back_url}/v1/center-groups/notification-channels/whatsapp`;
                return this.http.get<WhatsAppConfig>(url, { headers });
            })
        );
    }

    createWhatsAppConfig(config: WhatsAppCreateRequest): Observable<WhatsAppConfig> {
        return from(this.getAuthHeaders()).pipe(
            switchMap(headers => {
                const url = `${environment.cafler_backoffice_back_url}/v1/center-groups/notification-channels/whatsapp`;
                return this.http.post<WhatsAppConfig>(url, config, { headers });
            })
        );
    }

    updateWhatsAppConfig(config: WhatsAppUpdateRequest): Observable<WhatsAppConfig> {
        return from(this.getAuthHeaders()).pipe(
            switchMap(headers => {
                const url = `${environment.cafler_backoffice_back_url}/v1/center-groups/notification-channels/whatsapp`;
                return this.http.put<WhatsAppConfig>(url, config, { headers });
            })
        );
    }

    deleteWhatsAppConfig(): Observable<void> {
        return from(this.getAuthHeaders()).pipe(
            switchMap(headers => {
                const url = `${environment.cafler_backoffice_back_url}/v1/center-groups/notification-channels/whatsapp`;
                return this.http.delete<void>(url, { headers });
            })
        );
    }

    testWhatsAppConnection(): Observable<WhatsAppTestResponse> {
        return from(this.getAuthHeaders()).pipe(
            switchMap(headers => {
                const url = `${environment.cafler_backoffice_back_url}/v1/center-groups/notification-channels/whatsapp/test`;
                return this.http.post<WhatsAppTestResponse>(url, {}, { headers });
            })
        );
    }

    getLineConfig(): Observable<LineConfig | null> {
        return from(this.getAuthHeaders()).pipe(
            switchMap(headers => {
                const url = `${environment.cafler_backoffice_back_url}/v1/center-groups/notification-channels/line`;
                return this.http.get<LineConfig>(url, { headers });
            })
        );
    }

    createLineConfig(config: LineCreateRequest): Observable<LineConfig> {
        return from(this.getAuthHeaders()).pipe(
            switchMap(headers => {
                const url = `${environment.cafler_backoffice_back_url}/v1/center-groups/notification-channels/line`;
                return this.http.post<LineConfig>(url, config, { headers });
            })
        );
    }

    updateLineConfig(config: LineUpdateRequest): Observable<LineConfig> {
        return from(this.getAuthHeaders()).pipe(
            switchMap(headers => {
                const url = `${environment.cafler_backoffice_back_url}/v1/center-groups/notification-channels/line`;
                return this.http.put<LineConfig>(url, config, { headers });
            })
        );
    }

    deleteLineConfig(): Observable<void> {
        return from(this.getAuthHeaders()).pipe(
            switchMap(headers => {
                const url = `${environment.cafler_backoffice_back_url}/v1/center-groups/notification-channels/line`;
                return this.http.delete<void>(url, { headers });
            })
        );
    }

    testLineConnection(): Observable<LineTestResponse> {
        return from(this.getAuthHeaders()).pipe(
            switchMap(headers => {
                const url = `${environment.cafler_backoffice_back_url}/v1/center-groups/notification-channels/line/test`;
                return this.http.post<LineTestResponse>(url, {}, { headers });
            })
        );
    }

    getSmsConfig(): Observable<SmsConfig | null> {
        return from(this.getAuthHeaders()).pipe(
            switchMap(headers => {
                const url = `${environment.cafler_backoffice_back_url}/v1/center-groups/notification-channels/sms`;
                return this.http.get<SmsConfig>(url, { headers });
            })
        );
    }

    createSmsConfig(config: SmsCreateRequest): Observable<SmsConfig> {
        return from(this.getAuthHeaders()).pipe(
            switchMap(headers => {
                const url = `${environment.cafler_backoffice_back_url}/v1/center-groups/notification-channels/sms`;
                return this.http.post<SmsConfig>(url, config, { headers });
            })
        );
    }

    updateSmsConfig(config: SmsUpdateRequest): Observable<SmsConfig> {
        return from(this.getAuthHeaders()).pipe(
            switchMap(headers => {
                const url = `${environment.cafler_backoffice_back_url}/v1/center-groups/notification-channels/sms`;
                return this.http.put<SmsConfig>(url, config, { headers });
            })
        );
    }

    deleteSmsConfig(): Observable<void> {
        return from(this.getAuthHeaders()).pipe(
            switchMap(headers => {
                const url = `${environment.cafler_backoffice_back_url}/v1/center-groups/notification-channels/sms`;
                return this.http.delete<void>(url, { headers });
            })
        );
    }

    testSmsConnection(): Observable<SmsTestResponse> {
        return from(this.getAuthHeaders()).pipe(
            switchMap(headers => {
                const url = `${environment.cafler_backoffice_back_url}/v1/center-groups/notification-channels/sms/test`;
                return this.http.post<SmsTestResponse>(url, {}, { headers });
            })
        );
    }

    private async getAuthHeaders() {
        const token = await this.authService.getAccessToken();
        return {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        };
    }
}
